import React, { useState } from 'react';
import axios from 'axios';
import Alert from '../helpers/alert';
import { Text } from '../design-system';
import styled from 'styled-components';
import { FaCrosshairs } from 'react-icons/fa';
import { isExpired, parseDateValue, isClosed } from '../helpers/utils';

import DateField from './DateField';

const DatePickerContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

const CrossHairs = () => (
  <Text mr={1}>
    <FaCrosshairs color="red" />
  </Text>
);
interface DeadlineCellProps {
  cell: { value: string };
  row: { original: Record<string, any> };
  hasDaysLeftCol?: boolean;
  typeOverride?: string | false;
}

const DeadlineCell = ({
  cell: { value },
  row,
  hasDaysLeftCol,
  typeOverride = false,
}: DeadlineCellProps) => {
  const [selectedOption, setSelectedOption] = useState(() =>
    value && value !== 'never' ? parseDateValue(value).toDate() : null,
  );

  if (!value) return null;
  if (value === 'never') return value;
  const expired = isExpired(value);
  const completed = isClosed(row.original.status);

  const changeDate = async (dateChange: any) => {
    let deadlineType = 'action';
    let deadlineId = row.original.id;

    if (row.original.deadline_type) {
      deadlineType = row.original.deadline_type;
      deadlineId = row.original.entity_id;
    }

    if (typeOverride) {
      deadlineType = typeOverride;
      deadlineId = row.original.id;
    }

    if (!deadlineId) {
      console.error('Missing deadline ID, skipping update');
      return;
    }

    try {
      if (deadlineType === 'action') {
        await axios.put(`/action/${deadlineId}`, { deadline: dateChange });
      } else if (deadlineType === 'project') {
        await axios.put(`/project/update`, {
          id: deadlineId,
          deadline: dateChange,
        });
      }
      // Only reflect the new date in the UI once the server confirms it.
      setSelectedOption(dateChange);
    } catch (error) {
      Alert.error('Could not update the deadline. Please try again.');
    }
  };

  return (
    <DatePickerContainer>
      <DateField
        selected={selectedOption}
        onChange={changeDate}
        showPastDue={expired && !completed}
      />
      {row.original.hard_deadline && <CrossHairs />}
    </DatePickerContainer>
  );
};

export default DeadlineCell;
